import React from 'react'
import PropTypes from 'prop-types'
import Form from 'pages/widgets/form-actions/edit'
import PageTemplate from 'components/page-template'

const Page = ({ params: { id } }) => (
  <PageTemplate
    title='Update a Facebook Recurring Reminder Experience'
    description="that's where automagic happens"
    className='br-experience widgetBuilder'
  >
    <Form
      id={id}
      experiencePlatform='facebook'
      experienceType='facebook_recurring_reminder'
    />
  </PageTemplate>
)

Page.propTypes = {
  params: PropTypes.shape({ id: PropTypes.string }).isRequired
}

export default Page



// WEBPACK FOOTER //
// ./src/pages/widgets/fb-recurring-reminder/edit/index.js